import { AvailableCurrencies } from './availableCurrencies';

interface Currency {
  code: AvailableCurrencies;
  name: string;
  symbol: string;
  color: string;
  locale: string;
}

export const currencies: Record<AvailableCurrencies, Currency> = {
  ARS: {
    code: AvailableCurrencies.ARS,
    locale: 'es-AR',
    name: 'Peso Argentino',
    symbol: '$',
    color: 'bg-green-500',
  },
  CLP: {
    code: AvailableCurrencies.CLP,
    locale: 'es-CL',
    name: 'Peso Chileno',
    symbol: '$',
    color: 'bg-blue-500',
  },
  USD: {
    code: AvailableCurrencies.USD,
    locale: 'en-US',
    name: 'Dólar Estadounidense',
    symbol: '$',
    color: 'bg-green-500',
  },
  EUR: {
    code: AvailableCurrencies.EUR,
    locale: 'es-ES',
    name: 'Euro',
    symbol: '€',
    color: 'bg-green-500',
  },
  GBP: {
    code: AvailableCurrencies.GBP,
    locale: 'en-GB',
    name: 'Libra Esterlina',
    symbol: '£',
    color: 'bg-green-500',
  },
  JPY: {
    code: AvailableCurrencies.JPY,
    locale: 'ja-JP',
    name: 'Yen Japonés',
    symbol: '¥',
    color: 'bg-green-500',
  },
  CNY: {
    code: AvailableCurrencies.CNY,
    locale: 'zh-CN',
    name: 'Yuan Chino',
    symbol: '¥',
    color: 'bg-green-500',
  },
  AUD: {
    code: AvailableCurrencies.AUD,
    locale: 'en-AU',
    name: 'Dólar Australiano',
    symbol: '$',
    color: 'bg-green-500',
  },
  CAD: {
    code: AvailableCurrencies.CAD,
    locale: 'en-CA',
    name: 'Dólar Canadiense',
    symbol: '$',
    color: 'bg-green-500',
  },
  CHF: {
    code: AvailableCurrencies.CHF,
    locale: 'de-CH',
    name: 'Franco Suizo',
    symbol: 'Fr',
    color: 'bg-green-500',
  },
  SEK: {
    code: AvailableCurrencies.SEK,
    locale: 'sv-SE',
    name: 'Corona Sueca',
    symbol: 'kr',
    color: 'bg-green-500',
  },
  NOK: {
    code: AvailableCurrencies.NOK,
    locale: 'no-NO',
    name: 'Corona Noruega',
    symbol: 'kr',
    color: 'bg-green-500',
  },
  DKK: {
    code: AvailableCurrencies.DKK,
    locale: 'da-DK',
    name: 'Corona Danesa',
    symbol: 'kr',
    color: 'bg-green-500',
  },
  NZD: {
    code: AvailableCurrencies.NZD,
    locale: 'en-NZ',
    name: 'Dólar Neozelandés',
    symbol: '$',
    color: 'bg-green-500',
  },
  MXN: {
    code: AvailableCurrencies.MXN,
    locale: 'es-MX',
    name: 'Peso Mexicano',
    symbol: '$',
    color: 'bg-green-500',
  },
  BRL: {
    code: AvailableCurrencies.BRL,
    locale: 'pt-BR',
    name: 'Real Brasileño',
    symbol: 'R$',
    color: 'bg-green-500',
  },
  INR: {
    code: AvailableCurrencies.INR,
    locale: 'en-IN',
    name: 'Rupia India',
    symbol: '₹',
    color: 'bg-green-500',
  },
  RUB: {
    code: AvailableCurrencies.RUB,
    locale: 'ru-RU',
    name: 'Rublo Ruso',
    symbol: '₽',
    color: 'bg-green-500',
  },
  ZAR: {
    code: AvailableCurrencies.ZAR,
    locale: 'en-ZA',
    name: 'Rand Sudafricano',
    symbol: 'R',
    color: 'bg-green-500',
  },
  TRY: {
    code: AvailableCurrencies.TRY,
    locale: 'tr-TR',
    name: 'Lira Turca',
    symbol: '₺',
    color: 'bg-green-500',
  },
  AED: {
    code: AvailableCurrencies.AED,
    locale: 'ar-AE',
    name: 'Dirham de los Emiratos Árabes Unidos',
    symbol: 'AED',
    color: 'bg-green-500',
  },
  HKD: {
    code: AvailableCurrencies.HKD,
    locale: 'zh-HK',
    name: 'Dólar de Hong Kong',
    symbol: 'HK$',
    color: 'bg-green-500',
  },
  SGD: {
    code: AvailableCurrencies.SGD,
    locale: 'en-SG',
    name: 'Dólar de Singapur',
    symbol: 'S$',
    color: 'bg-green-500',
  },
  KRW: {
    code: AvailableCurrencies.KRW,
    locale: 'ko-KR',
    name: 'Won Surcoreano',
    symbol: '₩',
    color: 'bg-green-500',
  },
  TWD: {
    code: AvailableCurrencies.TWD,
    locale: 'zh-TW',
    name: 'Nuevo Dólar Taiwanés',
    symbol: 'NT$',
    color: 'bg-green-500',
  },
  MYR: {
    code: AvailableCurrencies.MYR,
    locale: 'ms-MY',
    name: 'Ringgit Malayo',
    symbol: 'RM',
    color: 'bg-green-500',
  },
  PHP: {
    code: AvailableCurrencies.PHP,
    locale: 'en-PH',
    name: 'Peso Filipino',
    symbol: '₱',
    color: 'bg-green-500',
  },
  THB: {
    code: AvailableCurrencies.THB,
    locale: 'th-TH',
    name: 'Baht Tailandés',
    symbol: '฿',
    color: 'bg-green-500',
  },
  VND: {
    code: AvailableCurrencies.VND,
    locale: 'vi-VN',
    name: 'Dong Vietnamita',
    symbol: '₫',
    color: 'bg-green-500',
  },
  IDR: {
    code: AvailableCurrencies.IDR,
    locale: 'id-ID',
    name: 'Rupia Indonesia',
    symbol: 'Rp',
    color: 'bg-green-500',
  },
  PLN: {
    code: AvailableCurrencies.PLN,
    locale: 'pl-PL',
    name: 'Złoty Polaco',
    symbol: 'zł',
    color: 'bg-green-500',
  },
  HUF: {
    code: AvailableCurrencies.HUF,
    locale: 'hu-HU',
    name: 'Forinto Húngaro',
    symbol: 'Ft',
    color: 'bg-green-500',
  },
  CZK: {
    code: AvailableCurrencies.CZK,
    locale: 'cs-CZ',
    name: 'Corona Checa',
    symbol: 'Kč',
    color: 'bg-green-500',
  },
  BGN: {
    code: AvailableCurrencies.BGN,
    locale: 'bg-BG',
    name: 'Lev Búlgaro',
    symbol: 'лв',
    color: 'bg-green-500',
  },
  RON: {
    code: AvailableCurrencies.RON,
    locale: 'ro-RO',
    name: 'Leu Rumano',
    symbol: 'lei',
    color: 'bg-green-500',
  },
  HRK: {
    code: AvailableCurrencies.HRK,
    locale: 'hr-HR',
    name: 'Kuna Croata',
    symbol: 'kn',
    color: 'bg-green-500',
  },
  ISK: {
    code: AvailableCurrencies.ISK,
    locale: 'is-IS',
    name: 'Corona Islandesa',
    symbol: 'kr',
    color: 'bg-green-500',
  },
  LVL: {
    code: AvailableCurrencies.LVL,
    locale: 'lv-LV',
    name: 'Lats Letón',
    symbol: 'Ls',
    color: 'bg-green-500',
  },
  LTL: {
    code: AvailableCurrencies.LTL,
    locale: 'lt-LT',
    name: 'Litas Lituano',
    symbol: 'Lt',
    color: 'bg-green-500',
  },
  EEK: {
    code: AvailableCurrencies.EEK,
    locale: 'et-EE',
    name: 'Corona Estonia',
    symbol: 'kr',
    color: 'bg-green-500',
  },
  MTL: {
    code: AvailableCurrencies.MTL,
    locale: 'mt-MT',
    name: 'Lira Maltesa',
    symbol: 'Lm',
    color: 'bg-green-500',
  },
  CYP: {
    code: AvailableCurrencies.CYP,
    locale: 'cy-GB',
    name: 'Libra Chipriota',
    symbol: '£',
    color: 'bg-green-500',
  },
};

/**
 * Coerce an arbitrary currency code (e.g. a raw string from the API) into a
 * supported {@link AvailableCurrencies}, falling back to CLP for unknown codes.
 * The cast is sound because it runs only after confirming membership in
 * `currencies`, so no `as` reaches an unvalidated value.
 */
export function resolveCurrency(currency: string): AvailableCurrencies {
  return Object.hasOwn(currencies, currency)
    ? (currency as AvailableCurrencies)
    : AvailableCurrencies.CLP;
}
